import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';

import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/500.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/fraunces/500-italic.css';
import '@fontsource/fraunces/600-italic.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import theme, { tokens } from './theme';
import App from './App';

// Small, global, MUI-native reset — kept here instead of a separate .css
// file. Everything else in the app is styled through the `sx` prop.
const globalStyles = (
  <GlobalStyles
    styles={{
      '*': { boxSizing: 'border-box' },
      html: { scrollBehavior: 'smooth' },
      body: { margin: 0, background: tokens.ink, overflowX: 'hidden', WebkitFontSmoothing: 'antialiased' },
      '::selection': { background: tokens.ember, color: tokens.ink },
      ':focus-visible': { outline: `2px solid ${tokens.frost}`, outlineOffset: '3px' },
    }}
  />
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
